import * as React from "react";
import { Grid } from "semantic-ui-react";
import Connector, { ASPECT_RATIO } from "../../Jigsaw/Connector";

//The Name is the direction it faces (ie: Left means it <- )
const GREEN = "#21ba45";
const YELLOW = "#fbbd08";
const BLUE = "#2185d0";
const RED = "#db2828";

interface Props {
	colour?: string;
	height?: number;
}

const Left: React.SFC<Props> = props => (
	<div
		style={{
			transform: "rotate(90deg)",
			right: ASPECT_RATIO * props.height - 3,
			position: "relative",
			zIndex: 2,
			display: "flex",
			alignSelf: "center",
			flex: `1 0 ${ASPECT_RATIO * props.height - 3}px`
		}}
	>
		<Connector
			colour={props.colour}
			style={{
				zIndex: 2,
				height: props.height,
				// transform: "rotate(90deg)",
				width: "auto"
				// width: ASPECT_RATIO * props.height - 3
			}}
		/>
	</div>
);

const Right: React.SFC<Props> = props => (
	<div
		style={{
			transform: "rotate(270deg)",
			// left: ASPECT_RATIO * props.height - 1,
			// left: 70,
			position: "relative",
			zIndex: 2,
			display: "flex",
			alignSelf: "center",
			right: "3px"
		}}
	>
		<Connector
			colour={props.colour}
			style={{
				height: props.height,
				zIndex: 2,
				width: "auto"
				// width: ASPECT_RATIO * props.height
			}}
		/>
	</div>
);

const Up: React.SFC<Props> = props => (
	<div
		style={{
			height: 0,
			position: "relative",
			zIndex: 2,
			display: "flex",
			top: `-${props.height || 82}px`
		}}
	>
		<Connector
			colour={props.colour}
			style={{
				// width: "50%",
				zIndex: 2,
				height: props.height,
				flexGrow: 1,
				transform: "scale(1,-1)",
				position: "relative"
				// top: `-${props.height}`
			}}
		/>
	</div>
);

const Down: React.SFC<Props> = props => (
	<div
		style={{ height: 0, position: "relative", zIndex: 2, display: "flex" }}
	>
		<Connector
			colour={props.colour}
			style={{
				flexGrow: 1,
				height: props.height,
				zIndex: 2,
				position: "relative"
			}}
		/>
	</div>
);

const Connectors = {
	Left: Left,
	Down: Down,
	Right: Right,
	Up: Up
};
export { Connectors };



// WEBPACK FOOTER //
// ./src/components/SubQuadNavigation/Connectors/Connectors.tsx